
import { useState, useRef, useEffect } from "react";
import { GraficoMetrosPorTear } from "../components/HistoricoDefeitos/GraficoMetrosPorTear";
import Menu from "../components/Menu";
import api from "../services/api";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import Loading from '../components/Loading';
import { GraficoMetrosPorOp } from "../components/HistoricoDefeitos/GraficoMetrosPorOp";
import { GraficoMetrosPorArt } from "../components/HistoricoDefeitos/GraficoMetrosPorArt";
import { GraficoMetrosPorTipoDef } from "../components/HistoricoDefeitos/GraficoMetrosPorTipoDef";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { TabelaPremioOperador } from "../components/HistoricoDefeitos/TabelaPremioTurma";
import { useReactToPrint } from "react-to-print";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

export default function HistoricoDefeitosGraf() {

    const [dadosPorTear, setDadosPorTear] = useState([]);
    const [dadosPorOperador, setDadosPorOperador] = useState([]);
    const [data, setData] = useState([]);
    const [dadosPorArtigo, setDadosPorArtigo] = useState([]);
    const [dadosPorDefeito, setDadosPorDefeito] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandido, setExpandido] = useState(null);
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [dados, setDados] = useState(false);

    const [turmas, setTurmas] = useState([]);
    const [defeitos, setDefeitos] = useState([]);

    const [turma, setTurma] = useState('');
    const [artigo, setArtigo] = useState('');
    const [defeito, setDefeito] = useState('');

    const graficosRef = useRef();

    const handlePrintAll = useReactToPrint({
        content: () => graficosRef.current
    });

    const showError = (error) => {
        toast.current.show({
            summary: 'Ocorreu um Erro',
            severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    }

    const toast = useRef(null);

    const handleClick = () => {
        if (initialDate === null || finalDate === null) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Preencha o campo "Data" para prosseguir'
            });
            return;
        }
        setLoading(true);
        let formated1 = initialDate.getFullYear() + '-' + (initialDate.getMonth() + 1) + '-' + initialDate.getDate();
        let formated2 = finalDate.getFullYear() + '-' + (finalDate.getMonth() + 1) + '-' + finalDate.getDate();

        api.get(`/defeitos/historico/graficos/${formated1}/${formated2}/${turma || null}/${artigo || null}/${defeito || null}`).then((response) => {
            setData(response.data);
            setDadosPorTear(response.data.por_tear || []);
            setDadosPorOperador(response.data.colaboradores || []);
            setDadosPorArtigo(response.data.por_artigo || []);
            setDadosPorDefeito(response.data.por_defeito || []);
            setDados(true);
            if (response.data.por_tear.length === 0 && response.data.por_operador.length === 0 && response.data.por_artigo.length === 0 && response.data.por_defeito.length === 0) {
                toast.current.show({
                    summary: 'Não encontrado',
                    severity: 'info',
                    detail: 'Nenhum registro encontrado para a data informada.'
                });
            }
        }).catch((error) => {
            showError(error);
            setDados(false);
        }).finally(() => {
            setLoading(false)
        });
    }

    
    useEffect(() => {
        carregarFiltrosIniciais();
    }, []);

    const carregarFiltrosIniciais = () => {
        let hoje = new Date();
        let formated = hoje.getFullYear() + '-' + (hoje.getMonth() + 1) + '-' + hoje.getDate();

        api.get(`/defeitos/historico/graficos/${formated}/${formated}/null/null/null/true`)
            .then((response) => {
                setTurmas(response.data.turmas || []);
                setDefeitos(response.data.defeitos || []);
            })
            .catch((error) => {
                console.error("Erro ao carregar os filtros iniciais", error);
            });
    };

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Card
                header={() => (
                    <div className="p-d-flex p-flex-row p-jc-between p-ai-start">
                        <h1 className="p-m-2">
                            Histórico de Defeitos por Gráficos - {data.periodo || ""}
                        </h1>
                    </div>
                )}
                className="p-m-3"
            >
                <div className="p-m-2">
                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Escolha a Data Inicial"
                        value={initialDate}
                    />

                    <Calendar
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Escolha a Data Final"
                        value={finalDate}
                    />

                    <Button
                        className="p-m-1 p-button-success"
                        icon="pi pi-refresh"
                        onClick={handleClick}
                    />
                </div>
                <div className="p-m-2">
                    <span><strong>Turma: </strong></span>
                    <Dropdown
                        value={turma}
                        options={turmas}
                        onChange={(e) => setTurma(e.value)}
                        optionLabel="nome"
                        optionValue="nome"
                        placeholder="Escolha uma Turma"
                        showClear
                        className="p-mr-3 p-ml-1"
                    />

                    <span><strong>Artigo: </strong></span>
                    <InputText
                        value={artigo}
                        onChange={(e) => setArtigo(e.target.value)} 
                        placeholder="Ex: 456"
                        className="p-mr-3 p-ml-1"
                    />

                    <span><strong>Tipo de defeito: </strong></span>
                    <Dropdown
                        value={defeito}
                        options={defeitos}
                        onChange={(e) => setDefeito(e.value)}
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="Escolha um Defeito"
                        showClear
                        filter
                        className="p-ml-1"
                    />
                </div>

                {loading ? (
                    <Loading />
                ) : !dados ? (
                    <div style={{ textAlign: 'center', padding: '2rem', fontSize: '1.2rem' }}>
                        Nenhum registro encontrado para o período informado.
                    </div>
                ) : (
                    <>
                        <div className="p-grid">

                            <GraficoMetrosPorTear
                                data={dadosPorTear}
                                expandido={expandido === 1}
                                onExpand={() =>
                                    setExpandido(expandido === 1 ? null : 1)
                                }
                            />

                            <GraficoMetrosPorOp
                                data={dadosPorOperador}
                                expandido={expandido === 2}
                                onExpand={() =>
                                    setExpandido(expandido === 2 ? null : 2)
                                }
                            />

                            <GraficoMetrosPorArt
                                data={dadosPorArtigo}
                                expandido={expandido === 3}
                                onExpand={() =>
                                    setExpandido(expandido === 3 ? null : 3)
                                }
                            />

                            <GraficoMetrosPorTipoDef
                                data={dadosPorDefeito}
                                expandido={expandido === 4}
                                onExpand={() =>
                                    setExpandido(expandido === 4 ? null : 4)
                                }
                            />

                        </div>

                        <div className="p-d-flex p-jc-end p-mt-4 p-mb-3">
                            <Button
                                label="Imprimir todas tabelas"
                                icon="pi pi-print"
                                onClick={handlePrintAll}
                            />
                        </div>

                        <div ref={graficosRef}>
                            {turma ? (
                                <>
                                    <div key={turma} style={{ pageBreakAfter: "always" }}>
                                        <TabelaPremioOperador 
                                            data={dadosPorOperador} 
                                            turma={turma} 
                                        />
                                    </div>
                                </>
                            ) : (
                                ["A", "B", "C", "D"].map((turma) => (
                                    <div key={turma} style={{ pageBreakAfter: "always" }}>
                                        <TabelaPremioOperador
                                            data={dadosPorOperador}
                                            turma={turma}
                                        />
                                    </div>
                                ))
                            )}
                        </div>
                    </>
                )}
            </Card>
        </div>
    );
}